import React from "react";
import { Box, Flex, Text, Button, Link } from "@chakra-ui/react";
import { GiWaterDrop } from "react-icons/gi";
import { IoIosPulse } from "react-icons/io";
import { FaFire } from "react-icons/fa";
import { RiAlertFill } from "react-icons/ri";
import { useSelector } from "react-redux";
import { LinkTo } from "../../../components/nav/components/LinkTo";
import { NavLink } from "react-router-dom";

const splitNairaKobo = (value) => {
  const num = parseFloat(value);
  if (!Number.isFinite(num) || num <= 0) return null;
  const [naira, kobo = "00"] = num.toFixed(2).split(".");
  return {
    naira: Number(naira).toLocaleString("en-NG"),
    kobo: kobo.padEnd(2, "0"),
  };
};

export const RateCard = ({
  rateData,
  pageColor: pageColorProp,
  utilityType: utilityTypeProp,
}) => {
  const fallbackDisplayData = useSelector(
    (state) => state?.switchTab?.currentDisplay?.dashboard?.rate,
  );
  const displayData = rateData || fallbackDisplayData || {};
  const { consumption, rate, unit } = displayData;
  const fallbackPageColor = useSelector(
    (state) => state?.switchTab?.brandColor?.brandColor,
  );
  const pageColor = pageColorProp || fallbackPageColor;

  const fallbackUtilityType = useSelector(
    (state) => state?.switchTab?.currentDisplay?.utilityType,
  );
  const utilityType = utilityTypeProp || fallbackUtilityType;

  const gas = utilityType === "gas";
  const water = utilityType === "water";
  const electricity = utilityType === "electricity";

  const parsed = splitNairaKobo(rate);
console.log(displayData, "display data in rate card")
  return (
    <Box
      bg="#fff"
      borderRadius="10px"
      p="20px"
      height={"200px"}
      className="box-info"
      shadow={"md"}
    >
      <Flex>
        <Box>
          <Text fontSize="20px" fontWeight="bold" color="primary" mb="5px">
            Rate
          </Text>
        </Box>
      </Flex>

      <Flex justifyContent="space-between">
        <Box>
          {parsed ? (
            <Flex alignItems="baseline" mt="10px" gap="1px">
              {/* ₦ symbol */}
              <Text fontSize="18px" fontWeight="bold" color="gray.700" lineHeight="1">
                ₦
              </Text>
              {/* Naira — large */}
              <Text fontSize="26px" fontWeight="bold" color="gray.800" lineHeight="1">
                {parsed.naira}
              </Text>
              {/* .kobo — smaller, muted */}
              <Text fontSize="14px" fontWeight="600" color="gray.400" lineHeight="1">
                .{parsed.kobo}
              </Text>
              {/* unit label */}
              {unit && (
                <Text fontSize="13px" color="gray.400" ml="4px" lineHeight="1">
                  {unit}
                </Text>
              )}
            </Flex>
          ) : (
            <Text fontSize="14px" color="gray.400" mt="10px">
              0.00 {unit || ""}
            </Text>
          )}
        </Box>
      </Flex>

      <Flex mt="15px" justifyContent="space-between">
        <Box>
          {water ? (
            <GiWaterDrop color={pageColor} size={30} />
          ) : gas ? (
            <FaFire color={pageColor} size={30} />
          ) : electricity ? (
            <IoIosPulse color={pageColor} size={30} />
          ) : (
            ""
          )}
        </Box>
      </Flex>
    </Box>
  );
};
